<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-optional", "data-active"];
import { computed, inject, provide, onBeforeUnmount, useId } from "vue";
import { useCookieItem } from "../composables/private/useCookieItem";
import {
  MagicCookieInstanceId,
  MagicCookieItemId,
  MagicCookieItemActive
} from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicCookieItem",
  props: {
    id: { type: String, required: false },
    optional: { type: Boolean, required: false },
    maxAge: { type: Number, required: false }
  },
  setup(__props) {
    const instanceId = inject(MagicCookieInstanceId, void 0);
    if (!instanceId) {
      throw new Error("MagicCookieItem must be nested inside MagicCookieProvider");
    }
    const mappedId = computed(() => __props.id ?? `magic-cookie-item-${useId()}`);
    const mappedActive = computed(() => item.active);
    const { initializeItem, deleteItem } = useCookieItem({
      instanceId
    });
    const item = initializeItem({
      id: mappedId.value,
      optional: __props.optional,
      maxAge: __props.maxAge
    });
    provide(MagicCookieItemId, mappedId.value);
    provide(MagicCookieItemActive, mappedActive);
    onBeforeUnmount(() => {
      deleteItem(mappedId.value);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "magic-cookie-item",
        "data-optional": _unref(item).optional,
        "data-active": _unref(item).active
      }, [
        _renderSlot(_ctx.$slots, "default", { item: _unref(item) })
      ], 8, _hoisted_1);
    };
  }
});
</script>

<style>
.magic-cookie-item {
  cursor: var(--magic-cookie-item-cursor, default);
}
</style>
